import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { EventProfile, EventProfileRow } from 'cb-model';
import {
  IsAllowed,
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';
import { EventProfileCard } from './EventProfileCard';

export const EventProfileSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        { fieldId: 'institution_id', operator: 'eq', value: '', display: 'hidden' },
        { fieldId: 'title', operator: 'sw', value: '' },
        { fieldId: 'status', operator: 'eq', value: 'ACTIVE' },
      ],
    },
  });
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(EventProfile, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(EventProfile, queryOptions);
  return (
    <>
      <PageTitle
        verb="Search"
        entity={EventProfile}
        subtitle="Find and manage Event Profiles. These control the types of user that can access and book your event (the 'Visibility Limit'), whether or not attendance is tracked, feedback is collected, and a certificate issues (the 'Post-Evenet Flow'), the default image and feedback form used for the event, and the Booking Payment Terms used for paid tickets."
      />
      <Section>
        <IsAllowed entity={EventProfile} action="create">
          <Link to="/admin/event-profile/create">
            <Button size="sm" variant="primary">
              Create Event Profile
            </Button>
          </Link>
          <div className="mb20px" />
        </IsAllowed>
        <PaginatorAndListSettings
          entity={EventProfile}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={(innerProps) => (
            <Search
              {...innerProps}
              render={(innerInnerProps) => (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', marginTop: '1rem' }}>
                  {innerInnerProps.rows.map((profile) => (
                    <Link
                      key={profile.id}
                      to={`/admin/event-profile/display/${profile.id}`}
                      style={{ textDecoration: 'none' }}
                    >
                      <EventProfileCard profile={profile} />
                    </Link>
                  ))}
                </div>
              )}
            />
          )}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
